import { FoxfordWidgetsConfig, FoxfordWidgets, WidgetsI } from '../../../index.d'

declare global {
  interface Window {
    FoxfordWidgets: FoxfordWidgets
  }
}

export class Widgets implements WidgetsI {
  private version: string

  constructor(version = 'latest') {
    this.version = version
  }

  async create(config: FoxfordWidgetsConfig): Promise<void> {
    if (!config) throw new Error('You must specify config for creating widgets')

    await this.loadAssets()
    if (!window.FoxfordWidgets) throw new Error('FoxfordWidgets not found in global scope')
    if (typeof window.FoxfordWidgets.create !== 'function')
      throw new Error('Not found function create in FoxfordWidgets library')

    window.FoxfordWidgets.create(config)
  }

  private async loadAssets() {
    if (!this.version) this.version = 'latest'

    return new Promise((resolve, reject) => {
      const url = `https://dist.ngcdn.ru/libs/foxford-widgets/${this.version}/foxford-widgets.js`
      const script = document.createElement('script')
      script.type = 'text/javascript'
      script.async = true
      script.onload = () => resolve(true)
      script.onerror = (event) => reject(event)
      script.src = url
      document.body.appendChild(script)
    })
  }
}
